import { Component, OnInit, ViewChild } from '@angular/core';
declare var jquery: any;
declare var $: any;
import 'datatables.net'
import { NewSatisfactionModalComponent } from "app/admin/new-satisfaction-modal/new-satisfaction-modal.component";
import { GridOptions } from "ag-grid/main";
import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Globals } from 'app/globals';
import { AdminService, ChoiceSetDto, ChoicesDto } from 'app/services/admin/AdminService';

@Component({
  selector: 'app-section2',
  templateUrl: './section2.component.html',
  styleUrls: ['./section2.component.scss']
})
export class Section2Component implements OnInit {
    currentTempId: number;

    @ViewChild('newsatisfaction', {static: true}) public newSatisfactionModal: NewSatisfactionModalComponent;
    //@ViewChild('newsatisfactionchoice') public newSatisfactionChoiceModal: NewSatisfactionChoiceModalComponent; 

    questions: string[] = [];
    choices: any[] = [];
    choiceSet: string[] = [];
    type: number = 5;
    sectionType: number = 5;
    showQuestionsTabContent: boolean = false;
    showChoicesTabContent: boolean = false;

    questionsHeaders: any[];
    choicesHeaders: any[];
    choiceSetHeaders: any[];

    gridOptions: GridOptions;
    gridApiQuestions;
    gridApiChoiceSet;
    gridApiChoices;
    gridColumnApi;
    overlayNoRowsTemplate;

    height: number;
    count: number;
    _onRowDragEnd: any;
    _onRowDragEnter: any;


    //new satisfaction choice modal
    text: string = "";
    actionEdit: boolean = false;
    actionCreate: boolean = false;
    currentIndex: number;
    languages: string[] = [];
    localizations: any[] = [];
    choiceId: number;
    //type: number = 1;
    //sectionId: number = 1;
    order: number;
    action: string;
    positiveP: number = 0;
    negativeP: number = 0;
    choiceSetName: string = '';
    choiceSetAction: string = '';
    choiceSetId: number = 0;

    newChoices: any[] = [];
    modifyChoices: any[] = [];
    deletedChoices: any[] = [];

    sectionName: string = "Section 2";

    rowSelection: string;

    canEdit: boolean = false;
    canDelete: boolean = false;

    canEditChoiceSet: boolean = false;
    canDeleteChoiceSet: boolean = false;

    canEditChoices: boolean = false;
    canDeleteChoices: boolean = false;

    currentRowIndex: number;

    constructor
        (
        private _AdminService: AdminService,
        private toastr: ToastrService,
        private router: Router,
        private _Globals: Globals
        ) {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "multiple";
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.questionsHeaders = this.createQuestionsHeaders();
        this.choicesHeaders = this.createChoicesHeaders();
        this.choiceSetHeaders = this.createChoiceSetHeaders();

        this.getAllQuestions();

        this.getLanguages();
    }

    tabSelected(tabIndex) {
        console.log(tabIndex);
        if (tabIndex === 1.1) {
            this.sizeToFit(this.gridApiQuestions);
        } else {
            this.GetChoiceSets();
        }
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 500);
    }

    getLanguages() {
        this._AdminService.getLanguages().subscribe((data: any) => {
            console.log('languages', data.result);
            let result = data.result.Result;

            if (result <= -10) {
                //this.toastr.warning('Expired token please login again.', 'ELI');
                this.router.navigate(['/login']);
                this._Globals.deleteAllStorage();
                return;
            }

            let _data = JSON.parse(data.result.Data);
            this.languages = _data;
        });
    }

    onResize(event: any) {
        //console.log("Width: " , event.currentTarget.innerWidth);
        //console.log("Height: " , event.currentTarget.innerHeight);
        setTimeout(() => {
            if (this.gridApiQuestions != undefined) {
                this.sizeToFit(this.gridApiQuestions);
            }
            if (this.gridApiChoiceSet != undefined) {
                this.sizeToFit(this.gridApiChoiceSet);
            }
            if (this.gridApiChoices != undefined) {
                this.sizeToFit(this.gridApiChoices);
            }
        }, 500);
    }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit(gridApi) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReadyQuestions(params) {
        this.gridApiQuestions = params.api;
        this._Globals.gridApis.push(this.gridApiQuestions);
        this.sizeToFit(this.gridApiQuestions);
    }

    getAllQuestions() {
//<<<<<<< HEAD
        //this.getQuestions.getQuestions(this.type).subscribe((data: any) => {
        //    console.log('response_GetQuestions', data);
        //    if (this._Globals.validationToken(data.result.Result)) {
        //        let _data = JSON.parse(data.result.Data);
        //        console.log('_data', _data);
        //        this.showQuestionsTabContent = true;
        //    }

        //=======
        this._AdminService.getQuestions(this.type).subscribe((data: any) => {
            console.log('response_getQuestions', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);

                this.questions = _data;
                this.showQuestionsTabContent = true;
            } 
//>>>>>>> 27b2aca204f1820bd88692508dcafc870121e6b8
        });
    }

    openModal(action, index?, text?: string) {
        console.log("Action: ", action);
        // we use the same new satisfaction modal instance because is the same process
        this.newSatisfactionModal.show(text, this, action, index, this.sectionType, true);
    }

    ngAfterViewInit() { }

    createQuestionsHeaders() {
        let columnDefs = new Array();

        //let actionsHeader = {
        //   headerName: 'Actions',
        //   field: '',
        //   minWidth: 85,
        //   width:85,
        //   suppressSizeToFit: true,
        //   suppressSorting: true,
        //   suppressMenu: true,
        //   cellRenderer: function (params) {
        //       let content = '';

        //       content += '<i id="editQuestion" class="material-icons custom-icons">edit</i>';

        //       content += '<i id="deleteQuestion" class="material-icons custom-icons">delete</i>';

        //       //content += '<i id="bulkUpload" class="material-icons custom-icons">file_upload</i>';

        //       return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

        //   }
        //};
        //columnDefs.push(actionsHeader);

        let nameHeader = {
            headerName: 'Text',
            field: 'Text',
            sort: 'asc',
            minWidth: 200,
            width: 200,
             headerCheckboxSelection: true,
             headerCheckboxSelectionFilteredOnly: true,
             checkboxSelection: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                //return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        return columnDefs;
    }

    public onRowClickedQuestions(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            this.editQuestion(data['Id'], data['Text']);

            //switch (e.event.target.id) {
            //    case "editQuestion":
            //        {
            //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //            this.editQuestion(data['Id'], data['Text']);
            //            break;
            //        }

            //    case "deleteQuestion":
            //        {
            //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //            this.deleteQuestion(data['Id']);
            //            break;
            //        }
            //}
        }
    }

    deselectAllCheckBox() {
        this.canEdit = false;
        this.canDelete = false;
        this.gridApiQuestions.forEachNode(function (node) {
            node.setSelected(false);
        });
    }

    onRowSelected(event) {
        console.log("onRowSelected", event);
        this.currentRowIndex = event.rowIndex;
        console.log('currentRowIndex', this.currentRowIndex);
    }

    onSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount == 1) {
            this.canEdit = true;
        } else {
            this.canEdit = false;
        }

        if (rowCount == 1) {
            this.canDelete = true;
        } else {
            this.canDelete = false;
        }
    }

    editSelected() {
        if (this.canEdit) {
            let selected = this.getSelectedRows();
            let id = selected[0].Id;
            let text = selected[0].Text;
            console.log("SELECTED ID", id);

            this.editQuestion(id, text);
        }
    }

    deleteSelected() {
        if (this.canDelete) {
            let selected = this.getSelectedRows();
            let id = selected[0].Id;
            console.log("SELECTED ID", id);

            this.deleteQuestion(id);
        }
    }

    getSelectedRows(): any {
        console.log("SELECTED", this.gridApiQuestions.getSelectedRows());
        return this.gridApiQuestions.getSelectedRows();
    }

    editQuestion(id: number, text: string) {
        console.log('edit');
        this.openModal('edit', id, text);
    }

    deleteQuestion(id: number) {
        console.log('delete');
        swal({
            title: 'Confirm Delete',
            text: "Are you sure you want to delete this question?",
            showCancelButton: true,
            focusConfirm: false,
            allowEnterKey: false,
            cancelButtonColor: '#888',
            confirmButtonColor: '#3472F7',
            confirmButtonText: 'Yes'
        }).then((result: any) => {
            if (result.value) {
                this._AdminService.DeleteQuestion(id).subscribe(data => {
                    console.log(data);
                    if (data.result.Result == 1) {
                        this.getAllQuestions();
                        this.toastr.success('Deleted successfully.', 'ELI');
                    } else {
                        this.toastr.error('An error has ocurred while trying to delete the section question.', 'ELI');
                    }

                });
            }
        });
    }


    /*-------------------------------------------------------------------------*/
    /*---------------------------Choice Sets Tab-------------------------------*/
    /*-------------------------------------------------------------------------*/

    GetChoiceSets() {
        this._AdminService.getChoiceSets(this.sectionType).subscribe(data => {
            console.log('response_getChoiceSets', data.result);
            this.choiceSet = data.result;

            this.showChoicesTabContent = true;
            setTimeout(() => {
                this.gridSize(this.choiceSet.length);
                this.sizeToFit(this.gridApiChoiceSet);
                this.deselectAllChoiceSetsCheckBox();
            }, 100);
        });
    }

    createChoiceSetHeaders() {
        let columnDefs = new Array();
        
        //let actionsHeader = {
        //   headerName: 'Actions',
        //   field: '',
        //   minWidth: 85,
        //   width:85,
        //   suppressSizeToFit: true,
        //   suppressSorting: true,
        //   suppressMenu: true,
        //   cellRenderer: function (params) {
        //       let content = '';

        //       content += '<i data-order="' + params.rowIndex + '" id="editChoiceSet" class="material-icons custom-icons">edit</i>';

        //       content += '<i data-order="' + params.rowIndex + '" id="deleteChoiceSet" class="material-icons custom-icons">delete</i>';

        //       return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

        //   }
        //};
        //columnDefs.push(actionsHeader);

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 200,
            suppressSorting: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            cellRenderer: function (params) {
                //return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        return columnDefs;
    }

    public onRowClickedChoiceSet(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            this.editChoiceSet(data['Id'], data['Name']);

            //switch (e.event.target.id) {
            //    case "editChoiceSet":
            //        {
            //            this.editChoiceSet(data['Id'], data['Name']);
            //            break;
            //        }
            //    case "deleteChoiceSet":
            //        {
            //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //            //this.deleteChoice(data['Id']);
            //            this.deleteChoiceSet(data['Id']);
            //            break;
            //        }
            //}
        }
    }

    onSelectionChangedChoiceSet(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount == 1) {
            this.canEditChoiceSet = true;
        } else {
            this.canEditChoiceSet = false;
        }

        if (rowCount > 0) {
            this.canDeleteChoiceSet = true;
        } else {
            this.canDeleteChoiceSet = false;
        }
    }

    deselectAllChoiceSetsCheckBox() {
        this.canEditChoiceSet = false;
        this.canDeleteChoiceSet = false;
        this.gridApiChoiceSet.forEachNode(function (node) {
            node.setSelected(false);
        });
    }

    editSelectedChoiceSet() {
        if (this.canEditChoiceSet) {
            let selected = this.getSelectedRowsChoiceSet();
            let id = selected[0].Id;
            let name = selected[0].Name;
            console.log("SELECTED ID", id);

            this.editChoiceSet(id, name);
        }
    }

    deleteSelectedChoiceSet() {
        if (this.canDeleteChoiceSet) {
            let selected = this.getSelectedRowsChoiceSet();
            console.log("SELECTED", selected);
        }
    }

    getSelectedRowsChoiceSet(): any {
        console.log("SELECTED", this.gridApiChoiceSet.getSelectedRows());
        return this.gridApiChoiceSet.getSelectedRows();
    }

    onGridReadyChoiceSet(params) {
        this.gridApiChoiceSet = params.api;
        this.sizeToFit(this.gridApiChoiceSet);
    }

    openChoiceSetModal(action: string) {
        this.choiceSetAction = action;
        $("#section2ModalChoiceSet").modal({ backdrop: "static" });
        $('#section2ModalChoiceSet').modal('show');
    }

    closeChoiceSetModal() {
        $('#section2ModalChoiceSet').modal('hide');
    }

    getChoiceSet(choiceSetId: number) {
        this._AdminService.getChoiceSet(choiceSetId).subscribe(data => {
            console.log('response_getChoiceSet', data.result);
            this.choices = data.result.Choices;

            setTimeout(() => {
                this.gridSize(this.choices.length);
                this.sizeToFit(this.gridApiChoices);
            }, 100);
        });
    }

    clearAll() {
        this.choices = [];
        this.modifyChoices = [];
        this.newChoices = [];
        this.deletedChoices = [];
        this.choiceSetName = '';
        this.choiceSetId = 0;
    }

    createChoiceSet() {
        this.clearAll();

        console.log('create choice set');
        this.openChoiceSetModal('Create');
    }

    editChoiceSet(choiceSetId: number, name: string) {
        this.clearAll();
        this.choiceSetId = choiceSetId;

        console.log('choiceSetId', choiceSetId);
        console.log('choiceSetName', name);
        this.choiceSetName = name;

        this.openChoiceSetModal('Edit');
        this.getChoiceSet(choiceSetId);
    }

    deleteChoiceSet(choiceSetId: number) {
        console.log('Delete choiceSet Id', choiceSetId);
    }

    saveChoiceSet() {
        console.log('saveChoiceSet');
        console.log('choiceSetId', this.choiceSetId);

        let name = $('#section2ChoiceSetName').val();
        console.log('name', name);

        if (name == '') {
            this.toastr.warning('Please enter the name for the current choice set.', 'ELI');
            return;
        }

        //get all choices
        let allChoices = this.modifyChoices.concat(this.newChoices.concat(this.deletedChoices));
        console.log(JSON.stringify(allChoices));

        let choiceSetDto = new ChoiceSetDto();
        choiceSetDto.ChoiceSetId = this.choiceSetId;
        choiceSetDto.Name = name;
        choiceSetDto.Choices = allChoices;
        choiceSetDto.SectionType = this.sectionType;

        if (this.choices.length == 0) {
            if (this.modifyChoices.length == 0 && this.newChoices.length == 0) {
                this.toastr.warning('Please enter at least one choice.', 'ELI');
                return;
            }
        }

        this.postSaveChoiceSet(choiceSetDto);

    }

    postSaveChoiceSet(choiceSetDto: ChoiceSetDto) {
        this._AdminService.postSaveChoiceSet(choiceSetDto).subscribe(data => {
            console.log('response_PostSaveChoiceSet', data.result);
            if (data.result.Result == 1) {
                this.toastr.success('Success', 'ELI');
                this.GetChoiceSets();
                this.closeChoiceSetModal();

            } else {
                this.toastr.error('Error', 'ELI');
            }

        })
    }

    /*-------------------------------------------------------------------------*/
    /*--------------------------------Choices methods--------------------------*/
    /*-------------------------------------------------------------------------*/

    getAllSectionChoices() {
        this._AdminService.getSectionChoices(this.sectionType).subscribe(data => {
            console.log('choices', data.result);
            this.choices = data.result;

            this.showChoicesTabContent = true;
            setTimeout(() => {
                this.gridSize(this.choices.length);
                this.sizeToFit(this.gridApiChoices);
            }, 100);
        });
    }

    createChoicesHeaders() {
        let columnDefs = new Array();
        
        //let actionsHeader = {
        //    headerName: 'Actions',
        //    field: '',
        //    minWidth: 85,
        //    width:85,
        //    suppressSizeToFit: true,
        //    suppressSorting: true,
        //    suppressMenu: true,
        //    cellRenderer: function (params) {
        //        let content = '';
 
        //        content += '<i data-order="' + params.rowIndex + '" id="editChoice" class="material-icons custom-icons">edit</i>';
 
        //        content += '<i id="deleteChoice" class="material-icons custom-icons">delete</i>';
 
        //        return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';
 
        //    }
        // };
        // columnDefs.push(actionsHeader);

        // let idHeader = {
        //     headerName: '',
        //     field: 'Id',
        //     minWidth: 15,
        //     width: 15,
        //     suppressSorting: true,
        //     suppressSizeToFit: false,
        //     headerCheckboxSelection: true,
        //     headerCheckboxSelectionFilteredOnly: true,
        //     checkboxSelection: true,
        //     cellRenderer: function (params) {
        //         return '';
        //     }
        // };
        // columnDefs.push(idHeader);

        let nameHeader = {
            headerName: 'Text',
            field: 'Text',
            minWidth: 200,
            width: 200,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            rowDrag: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.data.Text;
            }
        };
        columnDefs.push(nameHeader);

        return columnDefs;
    }

    public onRowClickedChoices(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            let order = e.rowIndex;

            if (data['Id'] == 0) {
                this.currentTempId = data['tempId'];
            }
            this.editChoice(data['Id'], data['Text'], order, this.currentTempId);

           //switch (e.event.target.id) {
           //    case "editChoice":
           //        {
           //            console.log('index');
           //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
           //            if (data['Id'] == 0) {
           //                this.currentTempId = data['tempId'];
           //            }
           //            this.editChoice(data['Id'], data['Text'], order, this.currentTempId);
           //            break;
           //        }

           //    case "deleteChoice":
           //        {
           //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
           //            this.deleteChoiceConfirmation(e.rowIndex);
           //            break;
           //        }

           //}
        }
    }

    onSelectionChangedChoices(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount == 1) {
            this.canEditChoices = true;
        } else {
            this.canEditChoices = false;
        }

        if (rowCount == 1) {
            this.canDeleteChoices = true;
        } else {
            this.canDeleteChoices = false;
        }
    }

    editSelectedChoices() {
        if (this.canEditChoices) {
            let data = this.getSelectedChoicesRows();
            console.log("SELECTED ID", data[0]);

            this.editChoice(data[0].Id, data[0].Text, this.currentRowIndex, data[0].tempId);
        }
    }

    deleteSelectedChoices() {
        if (this.canDeleteChoices) {
            let selected = this.getSelectedChoicesRows();
            let id = selected[0].Id;
            console.log("SELECTED ID", id);

            this.deleteChoiceConfirmation(this.currentRowIndex);
            this.deselectAllChoicesCheckBox();
        }
    }

    deselectAllChoicesCheckBox() {
        this.canEditChoices = false;
        this.canDeleteChoices = false;
        this.gridApiChoices.forEachNode(function (node) {
            node.setSelected(false);
        });
    }

    getSelectedChoicesRows(): any {
        console.log("SELECTED", this.gridApiChoices.getSelectedRows());
        return this.gridApiChoices.getSelectedRows();
    }

    onGridReadyChoices(params) {
        this.gridApiChoices = params.api;
        this.sizeToFit(this.gridApiChoices);
    }

    editChoice(id: number, text: string, currentIndex: number, tempId: number) {
        console.log('edit');
        this.currentIndex = currentIndex;
        this.currentTempId = tempId;
        this.openChoiceModal('edit', currentIndex, id, text);
    }

    deleteChoiceConfirmation(currentIndex: number) {
        console.log('delete confirmation');
        swal({
            title: '<span>Confirm Delete</span>',
            text: "Are you sure you want to delete this choice?",
            showCancelButton: true,
            focusConfirm: false,
            allowEnterKey: false,
            confirmButtonColor: '#3472F7',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#888',
            showCloseButton: true,
        }).then((result: any) => {
            if (result.value) {
                this.deleteChoice(currentIndex);


                //this._DeleteSectionChoice.DeleteSectionChoice(id).subscribe(data => {
                //    console.log(data);
                //    if (data.result.Result == 1) {
                //        this.getAllSectionChoices();
                //        this.toastr.success('Deleted successfully.', 'ELI');
                //    } else {
                //        this.toastr.error('An error has ocurred while trying to delete the section choice.', 'ELI');
                //    }

                //});

            }
        });
    }

    deleteChoice(currentIndex: number) {
        console.log('delete');

        var model = this.gridApiChoices.getModel();
        var rowNode = model.rowsToDisplay[currentIndex];
        //rowNode.setDataValue("Status", 2);

        //let rowNode = this.gridApi.getRowNode();
        let index = rowNode.rowIndex;
        model.rowsToDisplay.splice(index, 1);

        let nodeDeleted = this.choices[index];
        if (rowNode.data.Id != 0) {
            let choice = new ChoicesDto();

            choice.Id = nodeDeleted.Id;
            choice.Text = nodeDeleted.Text;
            choice.PositivePoints = 0;
            choice.NegativePoints = 0;
            choice.SectionId = this.sectionType;
            choice.Order = 0;
            choice.Status = 2;
            choice.Localizations = [];

            this.deletedChoices.push(choice);
        }

        this.choices.splice(index, 1);
        let currentTempId = rowNode.data.tempId;
        this.newChoices.forEach((x, index) => {
            if (x.tempId == currentTempId) {
                this.newChoices.splice(index, 1);
                console.log('founded and deleted on new choices array');
            }
        });
        console.log(this.newChoices);
        //this.deleteDeletedChoices(currentId, rowNode.data.LanguageShortCode);
        //let nodeToDelete = [rowNode.data];
        console.log('deleted choices', this.deletedChoices);
        let temChoices = this.choices;

        this.choices = [];

        setTimeout(() => {
            this.choices = temChoices;
            this.gridApiChoices.redrawRows();
            this.sizeToFit(this.gridApiChoices);
        }, 1);
    }

    openChoiceModal(action: string, order?: number, id?: number, text?: string, ) {
        console.log("Action: ", action);
        this.show(action, id, text, order);
    }

    changeSectionChoiceOrder(choiceId: number) {
        let input = {
            "ChoiceId": choiceId,
            "SectionId": this.sectionType,
            "FromIndex": this._onRowDragEnter,
            "ToIndex": this._onRowDragEnd
        }
        this._AdminService.putChangeSectionChoiceOrder(input).subscribe(data => {
            console.log('response ChangeSectionChoiceOrder', data);
            //this.getAllSectionChoices();
        });
    }

    onRowDragEnter(e) {
        console.log("onRowDragEnter", e);
        this._onRowDragEnter = e.overIndex + 1;
        console.log("onRowDragEnter", this._onRowDragEnter);
    }

    onRowDragEnd(e) {
        console.log("onRowDragEnd", e);
        this._onRowDragEnd = e.overIndex + 1;
        console.log("_onRowDragEnd", this._onRowDragEnd);
        let choiceId = e.node.data.Id;
        if (choiceId == 0) {
            //order for new choices with id 0
            this.move(this.newChoices, this._onRowDragEnter - 1, this._onRowDragEnd - 1);
        }
        else {
            //order for existing choices
            this.changeSectionChoiceOrder(choiceId);
        }

    }

    move(arr, old_index, new_index) {
        while (old_index < 0) {
            old_index += arr.length;
        }
        while (new_index < 0) {
            new_index += arr.length;
        }
        if (new_index >= arr.length) {
            var k = new_index - arr.length;
            while ((k--) + 1) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr;
    }


    /*modal satisfaction choices*/

    show(action: string, id: number, text: string, order: number): void {
        $('textarea').val(text);
        //this.parent = parent;
        this.choiceId = id;
        this.text = text;
        this.order = order;
        this.currentIndex = order;
        this.action = action;
        switch (action) {
            case "edit":
                this.actionEdit = true;
                if (this.choiceId != 0) {
                    let pos = this.modifyChoices.map(function (e) { return e.Id; }).indexOf(this.choiceId);
                    if (pos != -1) {
                        this.localizations = this.modifyChoices[pos].Localizations;
                        $('#s2positive').val(this.modifyChoices[pos].PositivePoints).toString();
                        $('#s2negative').val(this.modifyChoices[pos].NegativePoints).toString();
                    } else {
                        this.getChoice();
                    }
                } else {
                    console.log('newChoices', this.newChoices);
                    let currentChoiceTempId = this.currentTempId;
                    let pos = this.newChoices.map(function (e) { return e.tempId; }).indexOf(currentChoiceTempId);
                    if (pos != -1) {
                        console.log('found in new choices', this.newChoices[pos]);
                        $('#s2positive').val(this.newChoices[pos].PositivePoints).toString();
                        $('#s2negative').val(this.newChoices[pos].NegativePoints).toString();
                        this.localizations = this.newChoices[pos].Localizations;
                    }
                }

                break;
            case "create":
                $('#s2positive').val(0).toString();
                $('#s2negative').val(0).toString();
                this.actionCreate = true;
                break;
        }
        $("#section2ModalChoices").modal({ backdrop: "static" });
        $('#section2ModalChoices').modal('show');
    }

    getChoice() {
        this._AdminService.getSectionChoice(this.choiceId).subscribe(data => {
            console.log('choice', data.result);
            this.localizations = data.result.Localizations;
            this.positiveP = data.result.PositivePoints;
            this.negativeP = data.result.NegativePoints;

            $('#s2positive').val(this.positiveP).toString();
            $('#s2negative').val(this.negativeP).toString();
        })
    }

    onShown(): void {
    }

    closeChoicesModal(): void {
        console.log('close');
        $('#section2ModalChoices').modal('hide');
        this.resetActions();
    }

    resetActions() {
        this.actionCreate = false;
        this.actionEdit = false;
        $('#section2LanguagesChoice').prop('selectedIndex', 0);
        this.localizations = [];
        $('#section2TextareaChoice').val('');
        $('#s2positive').val(0).toString();
        $('#s2negative').val(0).toString();
    }

    saveChoice() {
        console.log('save choice');
        let text = $('#section2TextareaChoice').val();
        //let text = this.localizations[0].Text;
        if (text == '') {
            this.toastr.warning('Field empty', 'ELI');
            return;
        }

        let canAddChoice = false;
        for (var i = 0; i < this.localizations.length; i++) {
            if (this.localizations[i].LanguageShortCode == "en") {
                canAddChoice = true;
            }
        }

        if (!canAddChoice) {
            this.toastr.warning('English value for this choice cannot be empty.', 'ELI');
            return;
        }

        let choiceId = 0;
        let status = 0;
        if (!this.actionCreate) {
            choiceId = this.choiceId;
            status = 3;
        }

        //let sectionChoice = new SectionChoice();
        let choice = new ChoicesDto();

        let tempId = Math.floor(Math.random() * 1000) + 1;


        let newTempId;
        if (this.currentTempId == undefined) {
            newTempId = tempId;
        } else {
            newTempId = this.currentTempId;
        }


        let choiceText;
        this.localizations.forEach((x) => {
            if (x.LanguageShortCode === "en") {
                choiceText = x.Text;
            }
        });

        choice.tempId = newTempId;
        choice.Id = choiceId;
        choice.Text = choiceText;
        choice.PositivePoints = parseInt($('#s2positive').val().toString());
        choice.NegativePoints = parseInt($('#s2negative').val().toString());
        choice.SectionId = this.sectionType;
        choice.Order = 0;
        choice.Status = status;
        choice.Localizations = this.localizations;

        console.log('choice', JSON.stringify(choice));

        if (choiceId == 0) {
            //save the modified choices
            let pos = this.newChoices.map(function (e) { return e.tempId; }).indexOf(this.currentTempId);
            if (pos != -1) {
                this.newChoices[pos] = choice;
                var model = this.gridApiChoices.getModel();
                var rowNode = model.rowsToDisplay[this.currentIndex];
                rowNode.setDataValue("Text", choiceText);

            } else {
                this.newChoices.push(choice);


                let newChoice = {
                    "Id": choiceId,
                    "Status": 3,
                    "Text": choiceText,
                    "tempId": newTempId
                };
                this.choices.push(newChoice);
                var res = this.gridApiChoices.updateRowData({ add: [newChoice] });
            }

        } else {
            let pos = this.modifyChoices.map(function (e) { return e.Id; }).indexOf(choiceId);
            if (pos != -1) {
                this.modifyChoices[pos] = choice;
            } else {
                this.modifyChoices.push(choice);
            }
            var model = this.gridApiChoices.getModel();
            var rowNode = model.rowsToDisplay[this.currentIndex];
            rowNode.setDataValue("Text", choiceText);
            console.log('modifyChoices', this.modifyChoices);

        }

        console.log('choices', this.choices);
        $('#section2ModalChoices').modal('hide');
        setTimeout(() => {
            this.sizeToFit(this.gridApiChoices);
        }, 10);

        this.closeChoicesModal();

        //this._PostSaveSectionChoice.PostSaveSectionChoice(sectionChoice).subscribe(data => {
        //    console.log('_PostSaveSectionChoice response', data);
        //    if (data.result.Result == 1) {
        //        this.toastr.success('Choice edited successfully.', 'ELI');
        //        this.getAllSectionChoices();
        //        this.close();
        //    }
        //    else {
        //        this.toastr.error('Error. Please try again.', 'ELI');
        //    }
        //});
    }

    questionEmpty(text) {
        if (text == "") {
            $('#section2TextareaChoice').addClass('empty');
            setTimeout(function () {
                $('#section2TextareaChoice').removeClass('empty');
            }, 500);
            return;
        }
    }

    addLocalization(text: string, languageShortCode: string) {
        if (text != '') {
            console.log('setLocalization');
            if (this.localizations.length == 0) {
                this.localizations.push({ "LanguageShortCode": languageShortCode, "Text": text });
            }
            else {

                let arrayLength = this.localizations.length;
                let addNew = true;
                for (var i = 0; i < arrayLength; i++) {
                    if (this.localizations[i].LanguageShortCode == languageShortCode) {
                        //property exist
                        addNew = false;
                        this.localizations[i].Text = text;
                    }
                }
                if (addNew) {
                    //property not exist
                    this.localizations.push({ "LanguageShortCode": languageShortCode, "Text": text });
                }
            }
            console.log(this.localizations);
        }
    }

    clearTextArea() {
        $('#section2TextareaChoice').val('');
    }

    checkData(languageShortCode: string) {
        this.clearTextArea();
        console.log('check data', this.localizations);

        //check array for display data in text area if exist
        let arrayLength = this.localizations.length;
        for (var i = 0; i < arrayLength; i++) {
            if (languageShortCode == this.localizations[i].LanguageShortCode) {
                //property exist
                let text = this.localizations[i].Text;
                $('#section2TextareaChoice').val(text);
            }
        }

    }

    preventSpace(value: string, event: any) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $('#section2TextareaChoice').val('');
        }
    }

    preventLetters(event: any) {
        if (event.which < 48 || event.which > 57) {
            event.preventDefault();
            console.log('');
        }
    }

}
